/**
 * Rejection reasons returned verbatim by the upload endpoints (precheck and upload-sessions).
 * They must match the backend constants in `services/extras/file_service.py` exactly — the UI
 * distinguishes them to decide whether re-uploading later could ever succeed.
 */
export const FILE_ALREADY_EXISTS_ERROR = 'File already exists';

export const UPLOAD_IN_PROGRESS_ERROR =
  'This file is still being uploaded; wait for it to finish or try again in a few minutes';

export const BATCH_REJECTED_ERROR =
  'Upload rejected: another file in this batch failed validation';

export type UploadFileErrorKind =
  'duplicate' | 'inProgress' | 'batchRejected' | 'error';

export function classifyUploadError(
  error?: string,
): UploadFileErrorKind | undefined {
  if (!error) return undefined;
  if (error === FILE_ALREADY_EXISTS_ERROR) return 'duplicate';
  if (error === UPLOAD_IN_PROGRESS_ERROR) return 'inProgress';
  if (error === BATCH_REJECTED_ERROR) return 'batchRejected';
  return 'error';
}
